export default "__VITE_ASSET__DDEJY2LR__"